module.exports = __webpack_public_path__ + "img/1.980cf19b.webp";